import { render, staticRenderFns } from "./ScriptTask.vue?vue&type=template&id=2ad5d97a"
import script from "./ScriptTask.vue?vue&type=script&lang=js"
export * from "./ScriptTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports